export function handleRestAuthRegisterResponseError(restAuthError) {
    console.log('restAuthRegisterError')
    console.log(restAuthError)
    let errorMessage = ''
    let links = []
    if(restAuthError.response.data) {
        console.log('responseData')
        console.log(restAuthError.response.data)
        Object.keys(restAuthError.response.data).forEach((errorKey) => {
            if(errorKey=='errorMessages') {
                restAuthError.response.data[errorKey].forEach((message) => {
                    errorMessage += ` ${message}`
                    errorMessage += '\n'             
                })
            } else if(errorKey=='links') {
                   links = links.concat(restAuthError.response.data[errorKey])
            } else if(restAuthError.response.data[errorKey]) {
                console.log('num error messages', restAuthError.response.data[errorKey].errorMessages.length)
                restAuthError.response.data[errorKey].errorMessages.forEach((message) => {
                    errorMessage += ` ${message}`
                    errorMessage += '\n'             
                })
                if(restAuthError.response.data[errorKey].links) {
                    links = links.concat(restAuthError.response.data[errorKey].links)
                }
            }
        })
    }
    console.log(errorMessage)
    console.log(links)
    return {
        message: errorMessage,
        links: links
    }
}
export function handleRestAuthResponseError(restAuthError) {
    let errorMessage = ''
    console.log('restAuthError')
    console.log(restAuthError)
    if(restAuthError.response.data) {
        Object.keys(restAuthError.response.data).forEach((errorKey) => {
            // errorMessage += `${errorKey}:`
            restAuthError.response.data[errorKey].forEach((message) => {
                errorMessage += ` ${message}`
            })
            errorMessage += '\n'
        })
    }
    return errorMessage
}


